export default __webpack_public_path__ + "img/instagram.d2260ff068971713d7045c449832e352.svg";